import axios, { AxiosResponse } from 'axios';

export interface ISezUzivatelu {
    vypis: boolean;
    upis: boolean;
    sicav: boolean;
    srd: boolean;
    videtvypisyost: boolean;
    adminuziv: boolean;
    count: number;
    order: string;
    limit: number;
    offset: number;
    uzivatele: IUzivatel[];
}

export interface IUzivatel {
    id: number;
    jmeno: string;
    prijmeni: string;
    telefon: string;
    email: string;
    typprihlaseni: EAuthPrvek;
}

export enum EAuthPrvek {
    CERT = 'CERT', // certifikát
    PXKLIC = 'PXKLIC', // PX klíč
    UZIV = 'UZIV' // jméno a heslo
}

const prehledUzivateluApi = (offset: number) => {
    return axios({
        method: 'GET',
        url: '/UzivEmit/Prehled',
        params: {
            order: 'prijmeni:asc',
            limit: 10,
            offset: offset
        }
    }).then((resp: AxiosResponse<ISezUzivatelu>) => resp.data);
};
export default prehledUzivateluApi;
